import styled from 'styled-components'
import DoctorTalkingImg from 'presentation/assets/banners/doctor-talking.svg'

export const Wrapper = styled.div`
  height: 345px;
  width: 525px;
  display: flex;
  flex-direction: column;
  padding: 1.1rem 0;
`

export const Buttons = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-around;
  button {
    width: fit-content;
    padding: 0 3rem;
  }
`
export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  font-weight: bold;
  margin-bottom: 1rem;
  padding: 0 2rem;
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-image: url(${DoctorTalkingImg});
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  margin-bottom: 1rem;

  div {
    width: 50%;
    position: absolute;
    right: 2rem;

    ul {
      margin-top: 1rem;
      margin-left: 2rem;
    }
  }
`
export const ConfirmContent = styled.div`
  img {
    height: 90%;
    margin: 0 2rem 0.5rem;
  }

  ${Title} {
    text-align: center;
  }
`
